import { z } from 'zod';

import { getProviderJson } from '../providerClient';

export const messageAssistQuotaSchema = z.object({
  enabled: z.boolean(),
  used: z.number(),
  limit: z.number(),
  remaining: z.number(),
  windowHours: z.number(),
  resetsAt: z.string().nullable()
});

export type MessageAssistQuota = z.infer<typeof messageAssistQuotaSchema>;

export const getMessageAssistQuota = () =>
  getProviderJson('/providers/messaging/assist/quota', {
    schema: messageAssistQuotaSchema
  });
